<template>
  <div id="feedback_message" >
    <!-- 顶部导航栏 -->
    <van-nav-bar :title="$t('title.contact_customer_service')" placeholder fixed safe-area-inset-top @click-left="onClickLeft" left-arrow />
    
    <!-- 未读消息提示按钮 -->
    <div v-if="unreadCount > 0" class="unread-message-btn" @click="scrollToBottom">
      <span class="unread-count-badge">{{ unreadCount > 99 ? '99+' : unreadCount }}</span>
      <span class="unread-text">{{ $t('column.new_messages') || 'New Messages' }}</span>
    </div>
    
    <van-row>
      <van-col span="24" ref="scrollContainer">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list
              class="feedback_message_list"
          >
            <van-cell  v-for="(group, index) in groupedMessages" :key="index" class="messages-container">
              <!-- 时间分隔符 -->
              <div class="time-divider">{{ group.date }}</div>
              <!-- 循环每条消息 -->
              <div
                  v-for="msg in group.messages"
                  :key="msg.id"
                  :class="['message', msg.type]"
              >
                <!-- 接收方头像 -->
                <span v-if="msg.type === 'received'">
                 <img :src="msg.head_image" class="avatar" />
               </span>
                <!-- 消息内容 -->
                <div class="message-wrapper">
                  <div class="message-content">
                    <div v-if="msg.feedback_text || msg.order_id"><span v-if="msg.order_id">Order:{{ msg.order_id }}</span><span>{{ msg.feedback_text }}</span></div>
                    <div v-if="msg.feedback_img">
                      <img :src="msg.feedback_img" @click="previewImage(msg.feedback_img)"/>
                    </div>
                  </div>
                  <div v-if="msg.order_text" class="order-info">
                    {{ msg.order_text }}
                  </div>
                </div><!-- 发送方头像 -->
                <span v-if="msg.type === 'sent'">
                  <img :src="msg.head_image" alt="我的头像" class="avatar" />
                </span>
              </div>
            </van-cell>
            <div class="feedback_message_list_bottom"></div>
          </van-list>
        </van-pull-refresh>


      </van-col>
      <van-col span="24" class="feedback_message_bottom" v-if="message_status" >
        <van-col span="10" offset="1" class="feedback_message_bottom_left">
          <van-button color="#FF61F5" block round @click="onClickButton('solved')">{{ $t('column.solved') }}</van-button>
        </van-col>
        <van-col span="11" offset="1" class="feedback_message_bottom_right">
          <van-button color="#FF61F5" plain block round @click="onClickButton('feedback')">{{ $t('column.continued_questions') }}</van-button>
        </van-col>
      </van-col>
      <van-popup v-model="feedbackShow" round position="bottom" :style="{ paddingBottom: '5vw' }">
        <van-col span="22" offset="1">
          <van-col span="24" class="feedback_message_popup_title">{{ $t('column.continued_questions') }}: </van-col>
          <van-col span="24">
            <van-field
                v-model="message"
                rows="2"
                autosize
                class="feedback_message_popup_text"
                type="textarea"
                maxlength="500"
                :placeholder="$t('column.please_describe_problem_detail')"
                show-word-limit
            />
          </van-col>
          <van-col span="24">
            <!-- 上传图片 -->
            <van-col span="24">
              <uploadImage
                  ref="uploader"
                  class="help_form_upload"
                  :imageUrl="proof_img"
                  :cos-config="cosConfig"
                  v-if="iscos"
                  @successUploadImage="handleSuccess"
                  @errorUploadImage="handleError"
              />
            </van-col>
          </van-col>
          <van-col span="24" class="feedback_title_text">{{ $t('column.please_provide_that_assist_problems')}}</van-col>
          <van-col span="22" offset="1">
            <van-button class="help_form_btn" color="#FF61F5" block round @click="onClickSumbit">{{ $t('column.submit') }}</van-button>
          </van-col>
        </van-col>
      </van-popup>
    </van-row>
  </div>
</template>

<script>
import Toast from 'vant/lib/toast'
import axios from "axios";
import {Dialog, ImagePreview} from 'vant';
import UploadImage from "./upload_image.vue";

export default {
  components: {UploadImage},
  data() {
    return {
      message_status: 1,
      feedbackShow: false,
      ticket_id: undefined,
      loading: false,
      refreshing: false,
      list: [],
      finished: false,
      page: 1,
      message: undefined,
      iscos: false,
      proof_img: undefined,
      cosConfig: {
        tmpSecretKey: undefined,
        tmpSecretId: undefined,
        bucket: undefined,
        region: undefined,
        sessionToken: '',
        domain: '',
      },
      // 未读消息相关
      unreadCount: 0,
      lastReadMsgId: 0,
      unreadPollingTimer: null,
      isAtBottom: true
    }
  },
  computed: {
    // 按日期分组消息
    groupedMessages() {
      const groups = {};
      this.list.forEach(msg => {
        if (!groups[msg.date]) {
          groups[msg.date] = [];
        }
        groups[msg.date].push(msg);
      });
      // 转换为数组格式
      const result = Object.keys(groups).map(date => {
        return {
          date: date,
          messages: groups[date]
        };
      });
      console.log('分组后的消息:', result)
      return result;
    }
  },
  created() {
    this.ticket_id = this.$route.query.ticket_id
    this.getlist()
    this.getcosConfig()
    this.startUnreadPolling() // 启动未读消息轮询
  },
  mounted() {
    // 添加滚动监听
    window.addEventListener('scroll', this.handleScroll)
    // 初始化最后已读消息ID
    this.$nextTick(() => {
      if (this.list.length > 0) {
        const latestMsg = this.list[this.list.length - 1]
        this.lastReadMsgId = latestMsg.id || 0
      }
    })
  },
  beforeDestroy() {
    // 移除滚动监听
    window.removeEventListener('scroll', this.handleScroll)
    this.stopUnreadPolling() // 清除轮询
  },
  methods: {
    previewImage(url){
      ImagePreview({
        images: [ url ],
        closeable: true,
      })
    },
    onRefresh() {
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      console.log('下拉分页')
      this.getlist()
    },
    onClickSumbit() {
        const toast = this.$toast.loading({
          duration: 0, // 持续展示
          forbidClick: true,
          message: this.$t('other.Loading') + '...',
          className: 'custom-loading-toast' // 添加自定义类名
        });
        const uid = this.$route.query.uid
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=user_h5&act=add_feedback_message",{
          params:{
            uid: uid,
            token: token,
            message: this.message,
            ticket_id: this.ticket_id,
            proof_img: this.proof_img
          }
        }).then(res =>{
          localStorage.removeItem('feedbackStorage');
          toast.clear(); // 关闭加载提示
          if(res.data.status ===1){
            this.feedbackShow = false
            const newMsg = res.data.data
            // 确保 id 是数字类型
            newMsg.id = parseInt(newMsg.id) || 0
            // 如果后端没有返回 type 字段，则根据 sender_type 转换
            if (!newMsg.type) {
              newMsg.type = newMsg.sender_type === '1' || newMsg.sender_type === 1 ? 'sent' : 'received'
            }
            this.list.push(newMsg)
            // 更新最后已读消息ID
            this.lastReadMsgId = newMsg.id || this.lastReadMsgId
            // 滚动到底部
            this.scrollToBottom()
          }else{
            Toast(res.data.error)
          }
        })
    },
    onClickButton(name) {
      if (name === "solved") {
        // 是否结束完成本次订单
        this.complete_order()
      }else{
        // 发布信息
        this.message= undefined
        this.proof_img= undefined
        if (this.$refs.uploader && this.$refs.uploader.clearFile) {
          this.$refs.uploader.clearFile()
        }
        this.feedbackShow = true
      }
    },
    complete_order(){
      Dialog.confirm({
        title: this.$t('column.want_to_end_feedback'),
        confirmButtonColor: '#545AFF',
        confirmButtonText: this.$t('btn.confirm'),
        cancelButtonText: this.$t('btn.cancel'),
      }).then(() => {
        const uid = this.$route.query.uid
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=user_h5&act=feedback_end",{
          params:{
            uid: uid,
            token: token,
            ticket_id: this.ticket_id
          }
        }).then(res =>{

          if(res.data.status ===1){
            Toast({
              message: res.data.error,
              duration: 2000, // 持续2秒
              onClose: () => {
                // 这里写Toast关闭后要执行的方法
                this.onClickLeft()
              }
            })
          }else{
            Toast(res.data.error)
          }
        })
      })
    },
    getlist(){
      this.loading = false
      const toast1 = this.$toast.loading({
        duration: 0, // 持续展示
        forbidClick: true,
        message: this.$t('other.Loading') + '...',
        className: 'custom-loading-toast' // 添加自定义类名
      });
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=user_h5&act=feedback_chat",{ params:{ uid: uid, token: token, p: this.page, ticket_id: this.ticket_id }}).then(res =>{
        toast1.clear(); // 关闭加载提示
        this.finished = true
        this.refreshing = false
       
        if (res.data.status === 0) {
          Toast(res.data.error)
          return false
        }
        this.message_status = res.data.data.status
        if (this.page === 1) {
          this.list = []
        }
      
        // 接口返回的数据是降序（最新的在最后），需要反转后添加到列表
        const reversedList = [...res.data.data.list].reverse()
        for(let i = 0; i< reversedList.length; i ++) {
          const msg = reversedList[i]
          // 确保 id 是数字类型
          msg.id = parseInt(msg.id) || 0
          // 如果后端没有返回 type 字段，则根据 sender_type 转换
          if (!msg.type) {
            msg.type = msg.sender_type === '1' || msg.sender_type === 1 ? 'sent' : 'received'
          }
          console.log('消息加载:', msg.id, msg.sender_type, msg.type, msg.feedback_text)
          this.list.push(msg)
        }
        console.log('消息列表总数:', this.list.length)
        console.log('消息列表:', this.list)
        // 滚动到底部
        this.scrollToBottom()
        // 更新最后已读消息ID（仅在首次加载时）
        if (this.page === 1 && this.list.length > 0) {
          const latestMsg = this.list[this.list.length - 1]
          this.lastReadMsgId = latestMsg.id || 0
        }
        this.page ++
      })
    },
    getcosConfig(){
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=app&act=getCosSTS",{ params:{ uid: uid, token: token }}).then(res =>{
        console.log(res.data)
        if(res.data.status===1){
          this.cosConfig = res.data.data.sts
          this.iscos = true
        }else{
          this.$emit('errorUploadImage', res.data.error)
        }
      })
    },
    handleSuccess(url) {
      // 上传成功
      console.log('====handleSuccess====')
      console.log(url)
      this.proof_img = url
    },
    handleError(err) {
      console.log('====handleError====')
      // 上传失败
      Toast(err);
    },
    // 滚动到底部
    toScrollToBottom() {
      setTimeout(() => {
        this.$nextTick(() => {
          console.log(document.body.scrollHeight)
          // 方法1: 直接滚动整个页面
          window.scrollTo(0, document.body.scrollHeight + 250);
        });
      }, 500);
    },
    onClickLeft() {
      this.$router.go(-1)
    },
    scrollToBottom() {
      // 等待图片加载
      const images = document.images;
      let loaded = 0;
      const total = images.length;

      if (total === 0) {
        this.toScrollToBottom();
        return;
      }
      const checkLoaded = () => {
        loaded++;
        if (loaded === total) {
          this.toScrollToBottom();
        }
      };
      // 设置超时，确保不会无限等待
      setTimeout(() => {
        this.toScrollToBottom();
      }, 3000);
      // 检查每张图片
      for (let i = 0; i < total; i++) {
        if (images[i].complete) {
          checkLoaded();
        } else {
          images[i].addEventListener('load', checkLoaded);
          images[i].addEventListener('error', checkLoaded);
        }
      }
    },
    
    // 启动未读消息轮询
    startUnreadPolling() {
      this.unreadPollingTimer = setInterval(() => {
        this.checkUnreadMessages()
      }, 3000) // 每3秒检查一次
    },
    
    // 停止轮询
    stopUnreadPolling() {
      if (this.unreadPollingTimer) {
        clearInterval(this.unreadPollingTimer)
        this.unreadPollingTimer = null
      }
    },
    
    // 检查未读消息
    checkUnreadMessages() {
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=user_h5&act=feedback_chat", {
        params: {
          uid: uid,
          token: token,
          p: 1,
          ticket_id: this.ticket_id
        }
      }).then(res => {
        console.log('=== 轮询检测结果 ===')
        console.log('接口返回状态:', res.data.status)
        
        if (res.data.status === 1 && res.data.data.list) {
          const messages = res.data.data.list
          console.log('消息列表:', messages)
          console.log('消息列表长度:', messages.length)
          
          if (messages.length > 0) {
            // 打印第一条和最后一条消息的ID
            console.log('第一条消息ID:', messages[0].id)
            console.log('最后一条消息ID:', messages[messages.length - 1].id)
            
            // 找到最大的消息ID作为最新消息
            let maxMsgId = 0
            let latestMsg = null
            messages.forEach(msg => {
              const msgId = parseInt(msg.id) || 0
              if (msgId > maxMsgId) {
                maxMsgId = msgId
                latestMsg = msg
              }
            })
            
            const latestMsgId = maxMsgId
            
            console.log('最新消息ID:', latestMsgId)
            console.log('当前已读ID:', this.lastReadMsgId)
            console.log('是否在底部:', this.isAtBottom)
            
            // 如果最新消息ID大于已读ID，说明有新消息
            if (latestMsgId > this.lastReadMsgId) {
              console.log('检测到新消息！')
              // 计算新消息数量（找出所有ID大于已读ID的消息）
              const newMessages = messages.filter(msg => (parseInt(msg.id) || 0) > this.lastReadMsgId)
              console.log('新消息数量:', newMessages.length)
              console.log('新消息列表:', newMessages)
              
              // 只有当不在底部时才增加未读计数
              if (!this.isAtBottom) {
                console.log('用户不在底部，增加未读计数')
                // 统计对方发送的新消息
                const newReceivedMessages = newMessages.filter(msg => 
                  msg.sender_type === '2' || msg.sender_type === 2
                )
                this.unreadCount += newReceivedMessages.length
                console.log('未读计数:', this.unreadCount)
              } else {
                console.log('用户在底部，自动加载新消息')
                // 在底部时，自动加载新消息到列表
                this.loadNewMessages(newMessages)
                this.lastReadMsgId = latestMsgId
                this.unreadCount = 0
              }
            } else {
              console.log('没有新消息')
            }
          }
        }
        console.log('=== 轮询检测结束 ===')
      }).catch(err => {
        console.error('检查未读消息失败:', err)
      })
    },
    
    // 加载新消息到列表
    loadNewMessages(newMessages) {
      console.log('=== 开始加载新消息 ===')
      console.log('新消息数量:', newMessages.length)
      console.log('新消息列表:', newMessages)
      console.log('加载前消息总数:', this.list.length)
      
      // 转换并添加新消息
      newMessages.forEach(msg => {
        // 确保 id 是数字类型
        msg.id = parseInt(msg.id) || 0
        // 转换 sender_type 为 type
        if (!msg.type) {
          msg.type = msg.sender_type === '1' || msg.sender_type === 1 ? 'sent' : 'received'
        }
        console.log('添加消息:', msg.id, msg.type, msg.feedback_text)
        this.list.push(msg)
      })
      
      console.log('加载后消息总数:', this.list.length)
      console.log('=== 新消息加载完成 ===')
      
      // 强制更新视图
      this.$forceUpdate()
      
      // 滚动到底部
      if (newMessages.length > 0) {
        this.$nextTick(() => {
          this.toScrollToBottom()
        })
      }
    },
    
    // 滚动事件处理
    handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
      const clientHeight = window.innerHeight
      
      // 判断是否在底部（允许50px误差）
      this.isAtBottom = (scrollHeight - scrollTop - clientHeight) < 50
      
      // 如果滚动到底部，清除未读计数
      if (this.isAtBottom) {
        this.unreadCount = 0
        if (this.list.length > 0) {
          const latestMsg = this.list[this.list.length - 1]
          this.lastReadMsgId = latestMsg.id || 0
        }
      }
    }
  },


}
</script>
<style scoped>
#feedback_message .message-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

#feedback_message .message.sent .message-wrapper {
  align-items: flex-end;
}

#feedback_message .order-info {
  margin-top: 5px;
  font-size: 12px;
  color: #999;
  background-color: #f5f5f5;
  padding: 4px 8px;
  border-radius: 4px;
}

/* 未读消息按钮样式 */
.unread-message-btn {
  position: fixed;
  bottom: 100px;
  right: 20px;
  background: #FF61F5;
  color: white;
  padding: 8px 12px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  gap: 6px;
  box-shadow: 0 2px 8px rgba(255, 97, 245, 0.4);
  cursor: pointer;
  z-index: 1000;
  animation: bounce 0.5s ease;
}

.unread-count-badge {
  background: white;
  color: #FF61F5;
  font-size: 12px;
  font-weight: bold;
  padding: 2px 6px;
  border-radius: 10px;
  min-width: 18px;
  text-align: center;
}

.unread-text {
  font-size: 12px;
}

@keyframes bounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-5px); }
}
</style>



// WEBPACK FOOTER //
// src/components/feedback_message.vue